import { useCountdown, useMutation } from 'common/hooks';
import { sendVerificationEmailApi } from '../accounts.service';
import { EMAIL_RESEND_DELAY } from '../accounts.constants';

export const useSendVerificationEmail = () => {
  const { countdownDisplay, countdownTime, setCountdownTime } = useCountdown(EMAIL_RESEND_DELAY);
  const mutationResponse = useMutation(sendVerificationEmailApi, {
    showSuccessSnackbar: true,
    onSuccess: () => {
      setCountdownTime(EMAIL_RESEND_DELAY);
    },
  });
  return {
    ...mutationResponse,
    countdownDisplay,
    countdownTime,
  };
};
